import { aiApi } from "../utils/api";

export default function useRagga({ isAuthenticated, isGuest, isDev, notify, loginWithRedirect, getAccessTokenSilently, jobComments, setJobComments }) {

  const triggerRaggaComment = async (job) => {
    if (!isAuthenticated || isGuest) return;
    try {
      const result = await aiApi.getJobComment(job.id, {
        title: job.title || '',
        description: job.description || '',
        category: job.category || '',
        job_type: job.jobType || 'gefa',
      }, getAccessTokenSilently);
      if (result.success && result.data && !result.data.already_commented) {
        setJobComments(prev => [...prev, {
          id: result.data.id, user: 'Ragga 🤖', avatar: '🤖',
          text: result.data.text, time: 'rétt í þessu',
        }]);
      }
    } catch (err) { /* silent — Ragga comment is non-critical */ }
  };

  const handleRequestRaggaComment = async (job) => {
    if (!isAuthenticated && !isDev) { notify("⚠️ Þú þarft að skrá þig inn"); loginWithRedirect(); return null; }
    try {
      const existingTexts = jobComments.map(c => `${c.userName || 'Notandi'}: ${c.text}`);
      const result = await aiApi.getJobComment(job.id, {
        title: job.title || '', description: job.desc || job.description || '',
        category: job.category || '', job_type: job.jobType || 'gefa',
      }, getAccessTokenSilently, { existingComments: existingTexts, force: true });
      if (result.success && result.data) {
        setJobComments(prev => [...prev, {
          id: result.data.id || 'ragga-' + Date.now(), userName: 'Ragga 🤖', userAvatar: '🤖',
          text: result.data.text, time: 'rétt í þessu',
        }]);
      }
    } catch (err) {
      console.error('Ragga comment error:', err);
      notify("❌ Ragga gat ekki skrifað athugasemd");
    }
  };

  return { triggerRaggaComment, handleRequestRaggaComment };
}
